<template>
  <span class="wz_wrapChips">
    <!-- Visiteurs filtrés -->
    <v-flex xs12 sm12
      v-if="datasVisiteur.nb_alert"
      class="visiteurFiltrer"
    >
        <v-list-tile
          :class="{ 'light-blue lighten-4': visSelectId == datasVisiteur.visiteurID,  }"
          ripple
          v-bind:key="datasVisiteur.status"
          @click="checkChatVisiteur"
        >
          <wz-avatar
            v-if="!dejaEnChat && !datasVisiteur.network"
            :username="'#' + datasVisiteur.visiteurID"
            size="38px"
            class="pl-1"
          ></wz-avatar>
          <wz-avatar
            v-else-if="!dejaEnChat && datasVisiteur.network"
            :src="datasVisiteur.profile_pic"
            :username="datasVisiteur.visiteurName"
            size="38px"
            class="pl-1"
          ></wz-avatar>
          <wz-avatar
            v-else-if="!dejaEnChat && !istypingVisiteur && visiteurLastMessage && datasVisiteur.visiteurID != visSelectId"
            :username="'#' + datasVisiteur.visiteurID"
            size="38px"
            lastMessage
          ></wz-avatar>
          <wz-avatar
            v-else-if="!dejaEnChat && istypingVisiteur"
            :isTyping="istypingVisiteur"
            :username="'#' + datasVisiteur.visiteurID"
            size="38px"
            chip
          ></wz-avatar>

<!--           <wz-avatar-double
            v-else-if="dejaEnChat && !datasVisiteur.network"
            :avatars="[{id: datasVisiteur.visiteurName}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
          ></wz-avatar-double> -->

          <wz-avatar-double
            v-if="dejaEnChat && !istypingVisiteur && !visiteurLastMessage && datasVisiteur.visiteurID != visSelectId"
            :avatars="[{id: datasVisiteur.visiteurName, isTyping: false, chip: true, lastMessage: visiteurLastMessage}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
          ></wz-avatar-double>
          <wz-avatar-double
            v-else-if="dejaEnChat && !istypingVisiteur && !visiteurLastMessage && datasVisiteur.visiteurID == visSelectId"
            :avatars="[{id: datasVisiteur.visiteurName, isTyping: false, chip: true, lastMessage: visiteurLastMessage}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
          ></wz-avatar-double>
          <wz-avatar-double
            v-else-if="dejaEnChat && !istypingVisiteur && visiteurLastMessage && datasVisiteur.visiteurID != visSelectId"
            :avatars="[{id: datasVisiteur.visiteurName, isTyping: false, chip: true, lastMessage: visiteurLastMessage}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
          ></wz-avatar-double>
          <wz-avatar-double
            v-else-if="dejaEnChat && istypingVisiteur"
            :avatars="[{id: datasVisiteur.visiteurName, isTyping: true, chip: true}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
          ></wz-avatar-double>

          <wz-avatar-double
            v-else-if="datasVisiteur.network"
            :avatars="[{id: dejaEnChat.sessionID, username: datasVisiteur.visiteurName, src: datasVisiteur.profile_pic}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
          ></wz-avatar-double>

<!--           <wz-avatar-double
            v-else
            :avatars="[{id: datasVisiteur.visiteurName}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
          ></wz-avatar-double> -->

          <v-flex xs8>
            <v-list-tile-content>
              <v-list-tile-title>
                <v-tooltip bottom>
                  <div
                    slot="activator"
                    v-if="datasVisiteur.nb_alert && datasVisiteur.nb_alert != 0"
                    class="wz_alertFiltre secondary lighten-1 white--text"
                  >
                    <div>{{datasVisiteur.nb_alert}}</div>
                  </div>
                  <span>
                    Filtre activé : <br />
                    <div v-for="(alerte, index) in listeAlerte" :key="index">
                      {{index}} - {{alerte}}<br />
                    </div>
                  </span>
                </v-tooltip>
                
                <div v-if="datasVisiteur.nbCustomAlert && datasVisiteur.nbCustomAlert != 0" class="wz_alertPanier green  lighten-1 white--text">
                  <span>{{datasVisiteur.nbCustomAlert}}</span>
                </div>
                <div class="wz_nameVisiteur">{{datasVisiteur.shortdesc}}</div>
              </v-list-tile-title>
              <v-list-tile-sub-title v-if="datasVisiteur.pagesFocus">
                <div>{{ datasVisiteur.pagesFocus }}</div>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-flex>
          <!--
          <v-flex class="iconesListeVisiteurs text-xs-center" v-show="!visSelectId && datasVisiteur.listAlert && $vuetify.breakpoint.lgAndUp">
            <span class="secondary--text txtIcone txtMedium">{{numListeAlerte}}</span>
            <v-tooltip bottom>
              <v-icon large slot="activator" class="grey--text text--lighten-1">shopping_basket</v-icon>
              <span>Alert Panier : {{datasVisiteur.listAlert}}</span>
            </v-tooltip>
          </v-flex>
        -->
          <v-flex
            v-if="brideMenu('stats_leads_chaleur') === '1' && !searchVisitor"
            class="iconesListeVisiteurs text-xs-center" v-show="!visSelectId && $vuetify.breakpoint.lgAndUp"
          >
            <span class="secondary--text txtIcone txtMedium">{{datasVisiteur.ponderation}}°</span>
            <v-tooltip bottom>
              <v-icon large slot="activator" class="grey--text text--lighten-1">network_check</v-icon>
              <span>{{ $t('leadHeat') }}</span>
            </v-tooltip>
          </v-flex>

          <v-flex
            v-if="!searchVisitor"
            class="iconesListeVisiteurs text-xs-center" v-show="!visSelectId && $vuetify.breakpoint.mdAndUp"
          >
            <span class="secondary--text txtIcone txtMedium">{{visiteurAutoInvitSend}}</span>
            <v-tooltip bottom>
              <v-icon large slot="activator" class="grey--text text--lighten-1">local_offer</v-icon>
              <span>{{ $t('lastInvitAuto') | cap }}</span>
            </v-tooltip>
          </v-flex>

          <v-flex
            v-if="!searchVisitor"
            class="iconesListeVisiteurs text-xs-center" v-show="!visSelectId && $vuetify.breakpoint.smAndUp"
          >
            <span class="secondary--text txtIcone txtMedium">{{datasVisiteur.lang}}</span>
            <v-icon large class="grey--text text--lighten-1">language</v-icon>
          </v-flex>
          <v-flex
            v-if="!searchVisitor"
            class="iconesListeVisiteurs text-xs-center"
          >
            <v-icon v-if="visSelectId == datasVisiteur.visiteurID" large class="secondary--text text--lighten-1">textsms</v-icon>
            <div v-else-if="visiteurLastChat != null">
              <span 
                v-show="datasVisiteur.alreadyConsulted == 1 && !visSelectId"
                class="secondary--text txtIcone txtMedium"
              >{{visiteurLastChat}}</span>
              <v-tooltip bottom>
                <v-icon slot="activator" medium class="grey--text text--lighten-1">chat_bubble</v-icon>
                <span>{{ $t('lastMessageSent') }}</span>
              </v-tooltip>
            </div>
            <v-icon v-else medium class="grey--text text--lighten-1"></v-icon>
          </v-flex>

          <v-flex
            v-if="!searchVisitor"
            class="text-xs-center" v-show="!visSelectId && $vuetify.breakpoint.mdAndUp"
          >
            <v-tooltip bottom>
              <v-btn flat slot="activator" icon color="accent"
                @mouseover.native="overMenu = true"
                @mouseleave.native="overMenu = false"
                @click="stopAlert"
              >
                <v-icon large class="grey--text text--lighten-1">beenhere</v-icon>
              </v-btn>
              <span>{{ $t('disableAutoInvitation') }}</span>
            </v-tooltip>
          </v-flex>
        </v-list-tile>
    </v-flex>

    <!-- Visiteurs non filtrés -->
    <v-chip 
      v-else
      :class="{ 'light-blue lighten-4': visSelectId == datasVisiteur.visiteurID }"
      @click="checkChatVisiteur" 
    >
      <wz-avatar
        v-if="datasVisiteur.network"
        :src="datasVisiteur.profile_pic"
        :username="datasVisiteur.visiteurName"
        size="26px"
        chip
      ></wz-avatar>
      <wz-avatar
        v-else-if="!istypingVisiteur && visiteurLastMessage && datasVisiteur.visiteurID != visSelectId"
        :username="'#' + datasVisiteur.visiteurID"
        size="26px"
        lastMessage
      ></wz-avatar>
      <wz-avatar
        v-else
        :isTyping="istypingVisiteur"
        :username="'#' + datasVisiteur.visiteurID"
        size="26px"
        chip
      ></wz-avatar>

      <span
        v-if="istypingVisiteur && !visiteurLastMessage"
        class="wz_decalIdentity"
      >
        {{ identity }}
      </span>
      <span
        v-else-if="istypingVisiteur && visiteurLastMessage"
        class="wz_decalIdentity"
      >
        {{ identity }}
      </span>
      <span
        v-else-if="!istypingVisiteur && visiteurLastMessage && visSelectId != datasVisiteur.visiteurID"
        class="wz_nameLastMessage"
      >
        {{ identity }} <br> <i>{{visiteurLastMessage}}</i>
      </span>
      <span
        v-else
      >
        {{ identity }}
      </span>
      <wz-avatar
        class="avatarChipRight"
        v-if="dejaEnChat"
        :src="`${domaine}/public/media/user/small/${dejaEnChat.agentID}_avatar.jpg`"
        :username="dejaEnChat.agentName"
      ></wz-avatar>
    </v-chip>
    <!-- dialog entre dans discussion deja existante -->
    <v-dialog v-if="dejaEnChat" v-model="dialogDejaEnChat"  persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('conversationInProgress') }} !</v-card-title>
        <v-card-text>
          <div> {{ $tc('conversationInProgressWith', 1, {count: dejaEnChat.agentName}) }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="emitOpenChat()">{{ $t('yes') }}</v-btn>
          <v-btn flat @click="dialogDejaEnChat=false">{{ $t('no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<style>
.wz_alertFiltre{ margin-right:2px; width:26px; height:26px; float:left; text-align: center; line-height: 1.7em;}
.wz_alertPanier{margin-right:2px; width:26px; height:26px; float:left; text-align: center; line-height: 1.7em;}
.wz_iconeListeVisiteur{text-align: center; width: 20%;}
.wz_nameVisiteur{line-height: 1.7em;}
.txtIcone{display: block; }
.txtMedium{font-size: 0.8em;}
.txtLage{font-size: 1em;}
.cacheIcone{display:none;}
.avatarChipRight{margin-left: 20px !important; margin-right: -20px !important;}
.iconesListeVisiteurs{width: 78px; flex:inherit !important;}
.wz_decalIdentity{padding-top: 12px;}
.wz_nameLastMessage {max-width: 200px; line-height: 1em; overflow: hidden; text-overflow: ellipsis; }
.wz_wrapChips{display: inline-flex; width: 100%; margin-left: 8px;}
.v-chip .v-avatar {margin-left: 0px;}
.v-chip, .v-chip  {margin-right: 10px; }
.v-chip__content {padding: 0px 12px 0px 0px !important;}
</style>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { DOMAINE } from '../../constants'
import _watcheebox from '../watcheebox/watcheebox.js'
export default {
  props: ['datasVisiteur', 'visSelectId', 'searchVisitor'],
  data () {
    return {
      domaine: DOMAINE,
      histoChat: [],
      dialogDejaEnChat: false,
      overMenu: false
    }
  },

  mounted () {
    console.log(this.datasVisiteur)
    if (this.WATCHEEBOX_STATE.visiteurChatSelected === this.datasVisiteur.visiteurID) {
      this.emitOpenChat()
    }
  },

  methods: {
    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },
    // ----------------------------------------------------------------------------
    // Si ce visiteur est deja en chat
    // Check avec quel agent ce visiteur est en chat
    // si c'est moi j'ouvre le chat si c'est un autre agent j'ouvre une dialogBox
    // ----------------------------------------------------------------------------
    checkChatVisiteur () {
      if (this.overMenu) return
      if (this.visSelectId === this.datasVisiteur.visiteurID) return // pour eviter d'ouvrir un chat deja ouvert
      if (this.dejaEnChat) {
        if (this.dejaEnChat.agentID === this.user.id) {
          this.emitOpenChat()
        } else {
          this.dialogDejaEnChat = true
        }
      } else {
        this.emitOpenChat()
      }
    },

    // ----------------------------------------------------------------------------
    // Ouverture de la fenetre de chat
    // ----------------------------------------------------------------------------
    emitOpenChat () {
      console.log('emitOpenChat')
      this.dialogDejaEnChat = false // cache la dialogueBox
      // Pour eviter de rouvrir le meme chat
      if (this.visSelectId === this.datasVisiteur.visiteurID) return

      // var cloneVisiteur = _.cloneDeep(this.datasVisiteur)
      this.$emit('loading', this.datasVisiteur)
      // indique que la fiche visiteur est ouverte
      this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', this.datasVisiteur)

      // --------------- DEMANDE HISTORIQUE DE CHAT
      _watcheebox.firstLoadHistoChat(
        {
          chatSession: this.datasVisiteur.visiteurID,
          entrepriseId: this.user.entId
        }
      )
      .then(histoChat => {
        // recupere les infos du visiteur
        let vis = _.cloneDeep(this.datasVisiteur)
        vis.histoChat = histoChat
        if (this.datasVisiteur.network) {
          vis.visiteurName = this.datasVisiteur.visiteurName
        } else {
          vis.visiteurName = this.datasVisiteur.shortdesc
        }
        // this.$emit('update:datasVisiteur', vis)
        // console.log('--> vis', vis)
        this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', vis)
        this.$emit('openChat', vis)
      })
      .catch(e => {
      })
      // -------------------------------------------
    },

    // -------------------------------------------------------------
    // stop l'envois de message a ce visiteur
    // -------------------------------------------------------------
    stopAlert () {
      var config = {
        responseType: 'json',
        headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded'}
      }
      // ##############################
      // Evois en POST
      // ##############################
      let dataToPost = new window.FormData()
      dataToPost.append('visiteurID', this.datasVisiteur.visiteurID)
      this.axios.post('post/stop_alert.php', dataToPost, config)
      .then(response => {
        this.$emit('stopAlertVisiteur', this.datasVisiteur.visiteurID)
      })
      .catch()
      .then(_ => {
        // this.loading = false
      })
    },

    // -------------------------------------------------------------
    // ouvre une url et la transforme en lien clicable
    // -------------------------------------------------------------
    findUrls (text) {
      var source = (text || '').toString()
      var urlArray = []
      var matchArray
      // Regular expression to find FTP, HTTP(S) and email URLs.
      var regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&//=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g
      // Iterate through any URLs in the text.
      while ((matchArray = regexToken.exec(source)) !== null) {
        var token = matchArray[0]
        urlArray.push(token)
      }
      return urlArray
    }
  },

  watch: {
    'datasVisiteur.lastMessage': function (val, oldval) {
      console.log('lastMessage', val)
      if (!this.visSelectId && val) {
        this.$emit('loading', this.datasVisiteur)
        this.$emit('openChat', this.datasVisiteur)
      }
    }

    // 'newMessage': function (val, oldval) {
    //   if (val) {
    //     console.log('newMessage', val)
    //     console.log('this.visSelectId', this.visSelectId)
    //     if (!this.visSelectId) {
    //       this.$emit('loading', this.datasVisiteur)
    //       this.$emit('openChat', this.datasVisiteur)
    //     }
    //   }
    // }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['WATCHEEBOX_STATE', 'listeChatAgent', 'newMessage']),
    ...mapState('_User', ['brides']),
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),

    /**
     * @return {String} l'id du visiteur ou son prénom + nom
     */
    identity () {
      if (this.datasVisiteur.network) {
        return this.datasVisiteur.visiteurName
      } else {
        return _.isEmpty(_.trim(this.datasVisiteur.visiteurName))
          ? this.datasVisiteur.visiteurID
          : this.datasVisiteur.visiteurName
      }
    },

    // retourne la date du premier message chat (firstChat) avec moment
    visiteurLastChat () {
      // return this.datasVisiteur.firstChat
      if (this.datasVisiteur.dateLastChat && this.datasVisiteur.dateLastChat !== null) {
        return moment((this.datasVisiteur.dateLastChat * 1000)).fromNow()
      } else {
        return null
      }
    },

    // retourne la date du dernier envois de l'autoinvitation avec moment
    visiteurAutoInvitSend () {
      if (this.datasVisiteur.autoinvitSend) {
        return moment(this.datasVisiteur.autoinvitSend).fromNow()
      } else {
        return null
      }
    },

    // retourne la date du dernier envois de l'autoinvitation avec moment
    numListeAlerte () {
      if (this.datasVisiteur.listAlert) {
        return this.datasVisiteur.listAlert.length
      } else {
        return 0
      }
    },

    // retourne un tableau des alertes activées
    listeAlerte () {
      if (this.datasVisiteur.listAlert) {
        return this.datasVisiteur.listAlert
      } else {
        return 0
      }
    },

    // regarde si ce visiteur n'est pas en chat avec un autre agent
    // dejaEnChat () {
    //   var data = _.find(this.listeChatAgent, [0, this.datasVisiteur.visiteurID])
    //   if (data) {
    //     let userFound = this.$store.getters['_User/getUserById'](data[3])
    //     return {'sessionID': data[0], 'agentID': data[3], 'agentName': userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME}
    //   } else {
    //     return null
    //   }
    // },
    dejaEnChat () {
      if (!Array.isArray(this.listeChatAgent)) {
        return null
      }

      const data = _.find(this.listeChatAgent, [0, this.datasVisiteur.visiteurID])

      if (data) {
        const userFound = this.$store.getters['_User/getUserById'](data[3]) || {}
        return {
          sessionID: data[0],
          agentID: data[3],
          agentName: (userFound.USR_FIRST_NAME || '') + ' ' + (userFound.USR_LAST_NAME || '')
        }
      }

      return null
    },

    // regarde si ce visiteur ecrit un message (istyping)
    istypingVisiteur () {
      var typing = _.find(this.datasVisiteur.histoChat, {'isTyping': true, 'auteur': 'Visiteur'})
      if (typing) {
        return true
      } else {
        return null
      }
    },

    // affiche le dernier message chat du visiteur
    visiteurLastMessage () {
      // return this.datasVisiteur.firstChat
      if (this.datasVisiteur.lastMessage && this.datasVisiteur.lastMessage !== null) {
        return this.datasVisiteur.lastMessage
      } else {
        return null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzWatcheeboxVisiteur.vue